// extracted by mini-css-extract-plugin
export default {"heading":"ParentsDetails_heading__9+Q7m","container":"ParentsDetails_container__2-VxY","fatherHeader":"ParentsDetails_fatherHeader__2cVEp"};